// STEP 7d · owner decision 30-Oct-2026 10:47 KSA (D-c, point 4): the cash flow's INFO lines (e.g. a firm's own 41x9x / 51x9x
// code "Included in operating profit") — shown on the cash flow and on Validation in a neutral box, never with the warnings
// and never a check. The text comes from the engine (message / message_ar); the heading is EN + AR (1850_s7d_owner.js).
import React from "react";
import { asArray } from "@/lib/asArray";
import { useI18n } from "@/contexts/I18nContext";
import { cfText } from "@/pages/IFRSCashFlowItems";

export default function CashFlowInfo({ info, prior, testId = "cf-info" }) {
  const { t, lang } = useI18n();
  const list = [...asArray(info), ...asArray(prior).map((w) => ({ ...w, _prior: true }))];
  if (!list.length) return null;
  return (
    <div className="border-b bg-slate-50 px-4 py-2 text-[11px] text-slate-700 dark:bg-slate-900/40 dark:text-slate-300" data-testid={testId}>
      <div className="font-semibold">{t("s7do.cf.info")}</div>
      {list.map((w, i) => (
        <div key={`${w.key}-${i}`} data-testid={`${testId}-${w._prior ? "prior-" : ""}${w.key}`}>
          {w._prior ? `${cfText(lang, "priorYear")} ` : ""}{(lang === "ar" && w.message_ar) || w.message}
        </div>
      ))}
    </div>
  );
}
